import React from 'react'
import styles from './index.less'
const NotFound = ()=>{

  return (<img className={styles.notfoundimg} src="https://img.tuguaishou.com/ips_gif_asset/15/54/90/26/23/08/08283ed4431512754a82ea92406d3d93.gif?auth_key=2205244800-0-0-27a7b0d833a3c87d41e2215651577827" alt="404" />);

}
export default NotFound
